import React from "react";

const Image = ({ image }) => {
  return (
    <div className="col-md-4 my-2 d-flex justify-content-center align-items-center">
      <img src={image}></img>
    </div>
  );
};

export default Image;
